import * as React from "react";
import { Mutation, MutationFn } from "react-apollo";
import {
  DeleteUserMutation,
  DeleteUserMutationVariables
} from "../../__generated__/types";
import { DELETE_USER_QUERY } from "./queries";
import { ALL_USERS_QUERY } from "src/queries/UsersQuery/queries";

class DeleteUserM extends Mutation<DeleteUserMutation> {}

export interface Props {
  children(
    props: MutationFn<DeleteUserMutation, DeleteUserMutationVariables>
  ): JSX.Element | null;
}

export interface State {}

export default class DeleteUser extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <DeleteUserM
        mutation={DELETE_USER_QUERY}
        refetchQueries={[{ query: ALL_USERS_QUERY }]}
        awaitRefetchQueries={true}
      >
        {mutation => this.props.children(mutation)}
      </DeleteUserM>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mutations/DeleteUser/DeleteUser.tsx